import hotelService from '@/services/hotelService';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type Props = {
  hotelCode: string;
  bookmarkHotelCodes: string[] | null | undefined;
  size?: 30 | 40;
};

export default function HotelBookmarkIcon({ hotelCode, bookmarkHotelCodes, size = 30 }: Props) {
  const [loading, setLoading] = React.useState(false);
  const isBookMark = React.useMemo(() => {
    return bookmarkHotelCodes?.includes(hotelCode || '');
  }, [hotelCode, bookmarkHotelCodes]);

  const setHotelBookmark = (bookmark: boolean) => {
    setLoading(true);
    hotelService.bookmark(hotelCode || '', bookmark).finally(() => {
      setLoading(false);
    });
  };
  return (
    <button
      onClick={e => {
        e.preventDefault();
        setHotelBookmark(!isBookMark);
      }}
      disabled={loading}
      className={`button -red-1 bg-white border-light-1 size-${size} rounded-full shadow ${isBookMark ? 'bg-red-2' : ''}`}
    >
      {loading ? <FontAwesomeIcon icon={faSpinner} spin className="icon-heart text-12" /> : <i className="icon-heart text-12"></i>}
    </button>
  );
}
